import React, { useState } from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
import { useIntervalModel } from "../intervalModel";


export const DataBox = () => {
    const { exportApi, exportLoading } = useIntervalModel();

    const action = <>
        {/* <YhAuth resCode={ResourceAuthEnum.ST_STOCK_EX}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                loading={exportLoading}
                onClick={() => exportApi()}
            >导出</Button>
        </YhAuth > */}
    </>;

    return (
        <YhBox action={action}>
            <DataTable />
        </YhBox>
    )
}